module.exports = __webpack_public_path__ + "img/car-8.9cf04a71.png";